import { css } from 'linaria';

export const entranceDoorsBenefitsList = css`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  padding: 0;
  margin: 0;
  column-gap: 24px;
  list-style: none;

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 104px);
    column-gap: 16px;
    row-gap: 16px;
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-rows: auto;
    column-gap: 0;
    row-gap: 16px;
  }
`;

export const entranceDoorsBenefitsText = css`
  width: 230px;
  margin-top: 16px;

  @media (--to-desktop) {
    width: 100%;
  }

  @media (--only-tablet) {
    width: 240px;
  }
`;
